import WebServiceRequest from "../../../Api/WebServiceRequest";

class PhysicalCategoriesGetAll extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PhysicalCategory/GetAll");
  }
}
export default PhysicalCategoriesGetAll;
